<template>
  <el-input-number
    v-if="type === 'number'"
    :style="{ width: '80px' }"
    size="small"
    :default-value="defaultValue"
    @change="handleChange"
  />
  <el-switch
    v-else
    :default-checked="defaultValue"
    size="small"
    @change="handleChange"
  />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: [String, Boolean, Number],
      default: ""
    }
  },
  emits: ["inputChange"],
  methods: {
    handleChange(value) {
      this.$emit("inputChange", {
        value,
        key: this.name
      });
    }
  }
};
</script>
